export default __webpack_public_path__ + "static/media/plain-sticker-M.922a406b.png";